define [], () ->
  (RentappService, $http, Flash, RENTAPPLICATION_API_URL) ->
    restrict: "E"
    template: require("./passwordChangeForm.jade")
    link: (scope, element, attrs) ->
      scope.changePassword = () ->
        scope.accountSettingsErrors = []
        if scope.password != scope.newPasswordConfirm
          Flash.create("danger", "New password and new password confirmation do not match.")
          return

        scope.resettingPassword = true
        $http.post "#{RENTAPPLICATION_API_URL}/api/v1/user/reset_password/",
          currentPassword: scope.currentPassword
          newPassword: scope.password
        .then () ->
          Flash.create('success', 'Password settings successfully updated.', 3000, {class: 'profile-success'}, true)
          scope.password = null
          scope.currentPassword = null
          scope.newPasswordConfirm = null
        .catch (error) ->
          if error.status == 400
            Flash.create("danger", error.data.error, 3000, { class: 'error' }, true)
          else
            Flash.create("danger", "There was a problem resetting your password, please confirm your current password is provided correctly.", 3000, { class: 'error' }, true)
        .then ->
          scope.resettingPassword = false



// WEBPACK FOOTER //
// ./directives/passwordChangeForm/passwordChangeForm.coffee